import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { IconStylingModel } from '../icon/icon-styling.model';
export class AlertStylingModel extends CoreStylingModel {
/**
 * Styling for the alert toolbar element.
 */
toolbar?: {
    /**
     * Classes for toolbar section.
     */
    class?: string;
    /**
     * Dynamic classes for toolbar section.
     */
    dynamicClass?: any;
    /**
     * Styling for inform icon section.
     */
    inform?: {
      /**
       * Classes for inform icon section.
       */
      class?: string;
      /**
       * Dynamic classes for inform icon section.
       */
      dynamicClass?: any;
      /**
       * IconStylingModel for the alert informIcon element.
       */
      icon?: IconStylingModel;
    };
    /**
     * Styling for the alert content element.
     */
    content?: {
      /**
       * Classes for content section.
       */
      class?: string;
      /**
       * Dynamic classes for content section.
       */
      dynamicClass?: any;
      /**
       * StylingModel for the alert title element.
       */
      title?: StylingModel;
      /**
       * StylingModel for the alert message element.
       */
      message?: StylingModel;
      /**
       * StylingModel for the alert html template element.
       */
      template?: StylingModel;
    };
    /**
     * Styling for cancel icon section.
     */
    cancel?: {
      /**
       * Classes for cancel icon section.
       */
      class?: string;
      /**
       * Dynamic classes for cancel icon section.
       */
      dynamicClass?: any;
      /**
       * IconStylingModel for the alert cancelIcon element.
       */
      icon?: IconStylingModel;
    };
    /**
     * Styling for confirm icon section.
     */
    confirm?: {
      /**
       * Classes for confirm icon section.
       */
      class?: string;
      /**
       * Dynamic classes for confirm icon section.
       */
      dynamicClass?: any;
      /**
       * IconStylingModel for the alert confirmIcon element.
       */
      icon?: IconStylingModel;
    };
  };
/**
 * StylingModel for the alert progressBar element.
 */
progressBar?: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function AlertStylingModel_tsickle_Closure_declarations() {
/**
 * Styling for the alert toolbar element.
 * @type {?}
 */
AlertStylingModel.prototype.toolbar;
/**
 * StylingModel for the alert progressBar element.
 * @type {?}
 */
AlertStylingModel.prototype.progressBar;
}

